__turbopack_context__.v({
  "icon": "Icon-module__FGHQAW__icon",
});
